import { NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { RouterModule } from '@angular/router';

import { TmmsaisineSharedModule } from '../../shared';
import { InputTextModule, DataTableModule, ButtonModule, DialogModule, MultiSelectModule, AutoCompleteModule, DropdownModule } from 'primeng/primeng';


import {
    SaisineService,
    SaisineLineService,
    SaisineComponent,
    SaisineEditComponent,
    SaisineDetailComponent,
    SaisineRejectionsComponent,
    SaisineMasterProposalsComponent,
    SaisineSearchSolutionsComponent,
    SaisineSchoolValidationComponent,
    SaisineMasterProposalsStudentComponent,
    SaisineSearchSolutionsStudentComponent,
    SaisineAlertComponent,
    SaisineCommentComponent,
    saisineRoute,
    SaisineHistoryComponent,
    SaisineCanceledComponent
} from './';

let ENTITY_STATES = [
    ...saisineRoute
];

@NgModule({
    imports: [
        TmmsaisineSharedModule,
        InputTextModule, DataTableModule, ButtonModule, DialogModule, MultiSelectModule, AutoCompleteModule, DropdownModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        SaisineComponent,
        SaisineEditComponent,
        SaisineDetailComponent,
        SaisineRejectionsComponent,
        SaisineMasterProposalsComponent,
        SaisineSearchSolutionsComponent,
        SaisineSchoolValidationComponent,
        SaisineMasterProposalsStudentComponent,
        SaisineSearchSolutionsStudentComponent,
        SaisineAlertComponent,
        SaisineCommentComponent,
        SaisineHistoryComponent,
        SaisineCanceledComponent
    ],
    entryComponents: [
        SaisineComponent,
        SaisineEditComponent,
        SaisineAlertComponent,
    ],
    providers: [
        SaisineService,
        SaisineLineService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TmmsaisineSaisineModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/saisine/saisine.module.ts